"use client";

import { useState, useEffect } from "react";
import { Heart, Share2, Check } from "lucide-react";

export function ArticleActions({ slug }: { slug: string }) {
  const key = `clap:${slug}`;
  const [count, setCount] = useState(0);
  const [burst, setBurst] = useState(false);
  const [copied, setCopied] = useState(false);

  useEffect(() => {
    setCount(parseInt(localStorage.getItem(key) ?? "0", 10));
  }, [key]);

  function handleClap() {
    const next = count + 1;
    setCount(next);
    localStorage.setItem(key, String(next));
    setBurst(true);
    setTimeout(() => setBurst(false), 300);
  }

  async function handleShare() {
    const url = window.location.href;
    if (navigator.share) {
      try { await navigator.share({ url }); } catch {}
    } else {
      await navigator.clipboard.writeText(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }
  }

  return (
    <div className="flex items-center gap-5 mt-6">
      <button
        onClick={handleClap}
        aria-label={`Like this post (${count})`}
        className="flex items-center gap-2 group"
      >
        <span
          className={`flex items-center justify-center w-9 h-9 rounded-full border-2 transition-colors duration-150
            ${count > 0 ? "border-primary text-primary" : "border-black/25 text-black/40"}
            group-hover:border-primary group-hover:text-primary`}
          style={{ transform: burst ? "scale(1.25)" : "scale(1)", transition: "transform 0.15s cubic-bezier(0.34,1.56,0.64,1), color 0.15s, border-color 0.15s" }}
        >
          <Heart className="h-4 w-4" fill={count > 0 ? "currentColor" : "none"} strokeWidth={2} />
        </span>
        {count > 0 && (
          <span className="font-label-caps text-[12px] uppercase tracking-widest text-outline tabular-nums">
            {count}
          </span>
        )}
      </button>

      <button
        onClick={handleShare}
        aria-label="Share this post"
        className="flex items-center gap-2 group"
      >
        <span className="flex items-center justify-center w-9 h-9 rounded-full border-2 border-black/25 text-black/40 group-hover:border-primary group-hover:text-primary transition-colors duration-150">
          {copied ? <Check className="h-4 w-4" /> : <Share2 className="h-4 w-4" />}
        </span>
        <span className="font-label-caps text-[12px] uppercase tracking-widest text-outline">
          {copied ? "Copied" : "Share"}
        </span>
      </button>
    </div>
  );
}
